<template>
    <div>
        <form @submit.prevent="submit">
            <template v-if="isIdoso">
            
                <div class="row">
                    <form-select
                        v-model="educacao.idoso.frequenta_escola"
                        :itens="$root.arrays.frequenta_escola"
                        label="Frequenta escola ou creche?"
                        :required="true"
                        grid="6"
                    />
                    <form-select
                        v-model="educacao.idoso.sabe_ler"
                        :itens="$root.arrays.perguntas"
                        label="Sabe Ler e Escrever?"
                        :required="true"
                        grid="6"
                    />
                    <h2 class="col-12">
                        PARA A PESSOA QUE NÃO FREQUENTA ESCOLA, MAS JÁ FREQUENTOU
                    </h2>
                    <form-select
                        v-model="educacao.idoso.curso_frequentou"
                        :itens="$root.arrays.curso_frequentou"
                        label="Curso mais elevado que frequentou, no qual concluiu pelo menos uma série?"
                        :required="true"
                    />
                </div>
                <div class="row pt-4 px-0 d-flex justify-content-end">
                    <div class="col-auto px-2 text-right">
                        <button class="btn btn-success btn-submit" type="submit">
                            <i class="mdi mdi-content-save" />
                            {{ $t("Salvar") }}
                        </button>
                    </div>
                </div>
            </template>

            <template v-else>
                <div class="row">
                    <div class="col-12">

                        <h3>Pessoas Vinculadas ao Acolhimento:</h3>

                        <b-table :items="todasPessoas" :fields="['nome', 'idade', 'parentesco']" small responsive>
                            <template #cell(nome)="row">
                                <a href="#" @click.prevent="selecionarPessoa(row.item)">
                                    {{ row.item.nome }}
                                </a>
                            </template>
                        </b-table>

                        <div v-if="pessoaSelecionada">

                            <br><br>

                            <h3> Educação de: {{ pessoaSelecionada.nome }}</h3>

                            <div class="row">
                                <form-select
                                    v-model="caractEducacaoSelecionada.frequenta_escola"
                                    :itens="$root.arrays.frequenta_escola"
                                    label="Frequenta escola ou creche?"
                                    :required="true"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractEducacaoSelecionada.sabe_ler"
                                    :itens="$root.arrays.perguntas"
                                    label="Sabe Ler e Escrever?"
                                    :required="true"
                                    grid="6"
                                />
                                <h2 class="col-12">
                                    PARA A PESSOA QUE NÃO FREQUENTA ESCOLA, MAS JÁ FREQUENTOU
                                </h2>
                                <form-select
                                    v-model="caractEducacaoSelecionada.curso_frequentou"
                                    :itens="$root.arrays.curso_frequentou"
                                    label="Curso mais elevado que frequentou, no qual concluiu pelo menos uma série?"
                                    :required="true"
                                />
                            </div>
                            <div class="row pt-4 px-0 d-flex justify-content-end">
                                <div class="col-auto px-2 text-right">
                                    <button class="btn btn-success btn-submit" type="submit">
                                        <i class="mdi mdi-content-save" />
                                        {{ $t("Salvar") }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </form>
    </div>
</template>
<script>
    export default {
        props: ["item"],
        data() {
            return {
                educacao: {
                    idoso: {
                        frequenta_escola: null,
                        sabe_ler: null,
                        curso_frequentou: null,
                    },
                    pessoasVinculadas: []
                },
                caractEducacaoSelecionada: null,
                pessoaReferencia: [],
                pessoaSelecionada: null,
            };
        },
        watch: {
            item: {
                immediate: true,
                handler(newVal) {
                    if (newVal.educacao) {
                        this.educacao.idoso = newVal.educacao.idoso
                            ? this.preencherCamposEducacao(newVal.educacao.idoso)
                            : this.preencherCamposEducacao(null);

                        this.educacao.pessoasVinculadas = newVal.educacao.pessoasVinculadas || [];
                    } else {
                        this.educacao.idoso = this.preencherCamposEducacao(null);
                        this.educacao.pessoasVinculadas = [];
                    }

                    if (newVal.pessoaReferencia) {
                        this.pessoaReferencia = newVal.pessoaReferencia;
                    }
                }
            }
        },
        computed: {
            todasPessoas() {
                const pessoaPrincipal = {
                    id: 'principal',
                    nome: this.item.nome_acolhido,
                    idade: this.calcularIdade(this.item.nascimento),
                    parentesco: 'Acolhido(a)',
                    tipo_cadastro: 'Principal',
                };

                const vinculados = this.pessoaReferencia.filter(
                    p => p.tipo_cadastro === 'Familiar' || p.tipo_cadastro === 'Crianca'
                );

                return [pessoaPrincipal, ...vinculados];
            },
            isIdoso() {

                const hoje = moment();
                const nascimento = moment(this.item.nascimento, "YYYY-MM-DD");
                const idade = hoje.diff(nascimento, 'years');

                // Se existir público alvo, verifica se é 8, senão usa idade para decidir
                return this.item.solicitacao?.publico_alvo_id === 8 || idade >= 60;
            },
        },
        mounted() {

            if (this.item.educacao) {
                this.educacao.idoso = this.item.educacao?.idoso
                    ? this.preencherCamposEducacao(this.item.educacao.idoso)
                    : this.preencherCamposEducacao(null);

                this.educacao.pessoasVinculadas = this.item.educacao?.pessoasVinculadas || [];
            }

            if (this.item.pessoaReferencia != null) {
                this.pessoaReferencia = this.item.pessoaReferencia;
            }

        },
        methods: {
            calcularIdade(dataNasc) {
                if (!dataNasc) return null;
                const hoje = new Date();
                const nasc = new Date(dataNasc);
                let idade = hoje.getFullYear() - nasc.getFullYear();
                const m = hoje.getMonth() - nasc.getMonth();
                if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) {
                    idade--;
                }
                return idade;
            },
            preencherCamposEducacao(obj) {
                const campos = ['frequenta_escola', 'sabe_ler', 'curso_frequentou'];

                if (!obj) obj = {};
                campos.forEach(campo => {
                    if (obj[campo] === null || obj[campo] === undefined) {
                        obj[campo] = null;
                    }
                });

                return obj;
            },
            submit() {

                if (this.pessoaSelecionada) {
                    if (this.pessoaSelecionada.tipo_cadastro === 'Principal') {
                        this.educacao.idoso = { ...this.caractEducacaoSelecionada };
                    } else {
                        this.pessoaSelecionada.caracteristica_educacao = { ...this.caractEducacaoSelecionada };
                    }
                }

                this.item.educacao = {
                    idoso: this.educacao.idoso,
                    pessoasVinculadas: this.pessoaReferencia
                        .filter(p => p.caracteristica_educacao)
                        .map(p => ({
                            ...p.caracteristica_educacao,
                            pessoa_referencia_id: p.id,
                        }))
                };

                this.$emit("submit");
            },
            verificarValueArray(value, array, valueIsArray = false) {
                if (valueIsArray && value) {
                    var a = "";
                    for (var i = 0; i < value.length; i++) {
                        const result = array.filter(item => item.id == value[i]);
                        a += result[0].value + (i < value.length - 1 ? "," : "");
                    }
                    return a;
                } else {
                    const result = array.filter(item => item.id == value);
                    return result[0] ? result[0].value : "";
                }
            },  
            selecionarPessoa(pessoa) {
                this.pessoaSelecionada = pessoa;

                if (pessoa.tipo_cadastro === 'Principal') {

                    this.caractEducacaoSelecionada = { ...this.educacao.idoso };

                }else{
                    
                    const dadosEducacao = this.item.educacao?.pessoasVinculadas?.find(
                        cs => cs.pessoa_referencia_id === pessoa.id
                    );

                    this.caractEducacaoSelecionada = dadosEducacao
                        ? { ...dadosEducacao }
                        : {
                            pessoa_referencia_id: pessoa.id,
                            frequenta_escola: null,
                            sabe_ler: null,
                            curso_frequentou: null,
                        };
                }

            },
        }
    };
</script>
